export default {
  noContract: {
    id: 'enrollment_period_no_contract',
    defaultMessage: 'No contract',
  },
}
